<template>
    <div>
        <ui-modal v-ref:modal :width="400" :on-hidden="hidden">
            <div slot="header">
                <i style="font-size: 18px" class="fa fa-map-marker"></i>
                <span>Cadastrar Bairro</span>
            </div>
            <div class="pseudo-form" v-el:form data-name="form">
                <div v-if="step === 'create'">
                    <div class="row">
                        <div class="col-xs-12">
                            <form-select v-ref:state
                                         label="Estado"
                                         :model.sync="form.state_id"
                                         :options="states"
                                         :allow-empty="false"
                                         :disabled="true"
                                         :on-prefetched="formStateChanged"></form-select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12">
                            <form-select v-ref:city
                                         label="Cidade"
                                         :model.sync="form.city_id"
                                         :placeholder="formCityPlaceholder"
                                         :options="cities"
                                         :allow-empty="false"
                                         :disabled="true"
                                         :on-prefetched="formCityChanged"></form-select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12">
                            <form-text :model.sync="form.name" label="Nome do Bairro"></form-text>
                        </div>
                    </div>
                </div>
                <div v-if="step === 'ensure'">
                    <div>Você deseja realmente realizar o cadastro do bairro:</div>
                    <h4><b>{{ form.name }}</b></h4>
                    <div>Estado: {{ ui.state.name }}</div>
                    <div>Bairro: {{ ui.city.name }}</div>
                </div>
            </div>
            <div slot="footer">
                <button type="button" @click="hide()" class="btn btn-default">Fechar</button>
                <button type="button" @click="submit" class="btn orange">Salvar</button>
            </div>
        </ui-modal>
    </div>
</template>

<script>
    const R = require('ramda')
    const { client, vueChaos, Validator } = require('sci/helpers')

    const suggestionValidator = new Validator({
        rules: {
            state_id: 'required|numeric',
            city_id: 'required|numeric',
            name: 'really_not_empty'
        },
        messages: {
            state_id: 'Campo inválido',
            city_id: 'Campo inválido',
            name: 'Campo inválido',
        },
        attributes: {}
    })

    export default {
        props: {
            onComplete: {
                type: Function,
                default: null
            }
        },
        methods: {
            formStateChanged (id, state) {
                this.ui.state = state
            },
            formCityChanged (id, city) {
                this.ui.city = city
            },
            show (name = null, state_id, city_id) {
                this.form.name = name

                this.form.city_id = city_id
                this.form.state_id = state_id

                this.$refs.modal.show()
            },
            hidden () {
                this.step = 'create'

                this.form.name = null
            },
            hide () {
                this.$refs.modal.hide()
            },
            submit () {
                if (this.step === 'create') {
                    suggestionValidator
                        .validateForm(this.$els.form, this.form)
                        .then(() => {
                            this.step = 'ensure'
                        })
                } else {
                    client
                        .silent()
                        .post('Salvando...', '/locations/suggest-neighborhood', this.form)
                        .then((res) => {
                            if (res.errors.length > 0) {
                                this.step = 'create'
                                this.$nextTick(() => {
                                    vueChaos(this.$els.form)(res)
                                })
                            } else {
                                const { data } = res

                                this.$refs.modal.hide()

                                if (this.onComplete) {
                                    this.onComplete(data)
                                }

                                this.step = 'create'

                                this.form.name = null
                            }
                        })
                }
            },
            reloadCity () {
                if (this.$refs.neighborhood) {
                    this.$refs.neighborhood.reload()
                }
            },
            searchCities () {
                this.ui.loadingCities = true

                this.reloadCity()

                client
                    .silent()
                    .post('Carregando...', '/locations/cities', {
                        state_id: this.form.state_id,
                        per_page: 'max'
                    })
                    .then((res) => {
                        this.ui.loadingCities = false

                        this.cities = res.data

                        const city = R.head(res.data)
                        const exists = R.any(_ => String(_.id) === String(this.form.city_id), res.data)

                        if (!exists && city) {
                            this.form.city_id = city.id
                        } else if (!exists) {
                            this.form.city_id = null
                        }

                        this.reloadCity()
                    })
            }
        },
        computed: {
            formCityDisabled () {
                return this.ui.loadingCities ||
                    !this.form.state_id ||
                    this.cities.length < 1
            },
            formCityPlaceholder () {
                if (!this.form.state_id) {
                    return 'Escolha o Estado'
                }

                if (this.ui.loadingCities) {
                    return 'Carregando...'
                }

                return 'Cidade'
            }
        },
        watch: {
            'form.state_id' () {
                this.searchCities()
            },
            'form.city_id' () {
                // this.searchNeighborhoods()
            }
        },
        data () {
            return {
                step: 'create',
                form: {
                    state_id: null,
                    city_id: null,
                    street: null,
                    name: null
                },
                ui: {
                    city: null,
                    state: null,
                    loadingCities: false,
                    loadingNeighborhoods: false
                },
                cities: [],
                states: [
                    { id: 1, name: 'Acre', abbreviation: 'AC' },
                    { id: 2, name: 'Alagoas', abbreviation: 'AL' },
                    { id: 3, name: 'Amapá', abbreviation: 'AP' },
                    { id: 4, name: 'Amazonas', abbreviation: 'AM' },
                    { id: 5, name: 'Bahia', abbreviation: 'BA' },
                    { id: 6, name: 'Ceará', abbreviation: 'CE' },
                    { id: 7, name: 'Distrito Federal', abbreviation: 'DF' },
                    { id: 8, name: 'Espírito Santo', abbreviation: 'ES' },
                    { id: 9, name: 'Goiás', abbreviation: 'GO' },
                    { id: 10, name: 'Maranhão', abbreviation: 'MA' },
                    { id: 11, name: 'Mato Grosso', abbreviation: 'MT' },
                    { id: 12, name: 'Mato Grosso do Sul', abbreviation: 'MS' },
                    { id: 13, name: 'Minas Gerais', abbreviation: 'MG' },
                    { id: 14, name: 'Pará', abbreviation: 'PA' },
                    { id: 15, name: 'Paraíba', abbreviation: 'PB' },
                    { id: 16, name: 'Paraná', abbreviation: 'PR' },
                    { id: 17, name: 'Pernambuco', abbreviation: 'PE' },
                    { id: 18, name: 'Piauí', abbreviation: 'PI' },
                    { id: 19, name: 'Rio de Janeiro', abbreviation: 'RJ' },
                    { id: 20, name: 'Rio Grande do Norte', abbreviation: 'RN' },
                    { id: 21, name: 'Rio Grande do Sul', abbreviation: 'RS' },
                    { id: 22, name: 'Rondônia', abbreviation: 'RO' },
                    { id: 23, name: 'Roraima', abbreviation: 'RR' },
                    { id: 24, name: 'Santa Catarina', abbreviation: 'SC' },
                    { id: 25, name: 'São Paulo', abbreviation: 'SP' },
                    { id: 26, name: 'Sergipe', abbreviation: 'SE' },
                    { id: 27, name: 'Tocantins', abbreviation: 'TO' }
                ]
            }
        }
    }

</script>


// WEBPACK FOOTER //
// SuggestNeighborhoodModal.vue?f29d3012